export const BaseDict = {
    FirstHalf: "H1",
    SecondHalf: "H2",
    Goal: "Goal",
    Corner: "Corner",
    Penalty: "Penalty",
    YellowCard: "Yellow Card",
    RedCard: "Red Card",
    MinAgo: "m ago",
    Now: "now",
    goals: "Goals",
    yellowCards: "Yellow Cards",
    corners: "Corners",
    penalties: "Penalties",
    redCards: "Red Cards",
    noIncidents: "No incidents yet",
    infoLabel: "Info",
    legendText: "An In-Play Aggregate is a bet on a group of games in the same league or competition played at the same time. The action in all the games determines the result of the bet An In-Play Aggregate is a bet on a group of games in the same league or competition played at the same time. The action in all the games determines the result of the bet"
};
//# sourceMappingURL=dict.js.map